import { useMemo } from "react";

export default function StarryBackground() {
  // 40 hand-placed twinkling stars on top of the CSS layer for extra magic
  const stars = useMemo(
    () =>
      Array.from({ length: 40 }, (_, i) => ({
        id: i,
        top: Math.random() * 100,
        left: Math.random() * 100,
        size: Math.random() * 2 + 1,
        delay: Math.random() * 5,
        duration: 3 + Math.random() * 4,
      })),
    []
  );

  return (
    <div className="starry-bg" aria-hidden="true" data-testid="starry-background">
      {stars.map((s) => (
        <span
          key={s.id}
          className="star-twinkle"
          style={{
            top: `${s.top}%`,
            left: `${s.left}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            animationDelay: `${s.delay}s`,
            animationDuration: `${s.duration}s`,
          }}
        />
      ))}
      {/* Moon */}
      <div
        className="moon-glow"
        style={{
          position: "absolute",
          top: "8%",
          right: "8%",
          width: 90,
          height: 90,
          borderRadius: "9999px",
          background:
            "radial-gradient(circle at 35% 35%, #FEF3C7 0%, #FBBF24 55%, #F59E0B 100%)",
          opacity: 0.85,
        }}
      />
    </div>
  );
}
